import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { JwtModule } from '@auth0/angular-jwt';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { tokenGetter } from './constants';
import { CartInterceptor } from './interceptors/cart.interceptor';
import { UnauthorizedInterceptor } from './interceptors/unauthorized.interceptor';
import { LoginPageComponent } from './login-page/login-page.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderComponent } from './loader/loader.component';
import { LoaderSpinnerComponent } from './loader-spinner/loader-spinner.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordHashComponent } from './reset-password-hash/reset-password-hash.component';
import { SidenavPopupComponent } from './store/sidenav-popup/sidenav-popup.component';
import { WholesaleLoginComponent } from './wholesale-login/wholesale-login.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    LoaderSpinnerComponent,
    LoginPageComponent,
    ResetPasswordComponent,
    ResetPasswordHashComponent,
    SidenavPopupComponent,
    WholesaleLoginComponent,
  ],
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSidenavModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: [
          'polyvinylrecords.com',
          'localhost:3000',
          'localhost:4000'
        ]
      }
    }),
    BrowserAnimationsModule,
  ],
  providers: [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CartInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: UnauthorizedInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
